var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPaymentIconMaster(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 32,
    viewBox: "0 0 46 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6a6 6 0 016-6h34a6 6 0 016 6v20a6 6 0 01-6 6H6a6 6 0 01-6-6V6z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.905 22.44a9.07 9.07 0 01-5.864 2.133c-4.993 0-9.041-4-9.041-8.933 0-4.934 4.048-8.933 9.04-8.933a9.07 9.07 0 015.865 2.134 9.07 9.07 0 015.865-2.134c4.993 0 9.04 4 9.04 8.933 0 4.934-4.047 8.933-9.04 8.933a9.07 9.07 0 01-5.865-2.134z",
    fill: "#ED0006"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.905 22.44a8.87 8.87 0 003.177-6.8 8.87 8.87 0 00-3.177-6.8 9.07 9.07 0 015.865-2.133c4.993 0 9.04 4 9.04 8.933 0 4.934-4.047 8.933-9.04 8.933a9.07 9.07 0 01-5.865-2.134z",
    fill: "#F9A000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.905 22.44a8.87 8.87 0 003.177-6.8 8.87 8.87 0 00-3.177-6.8 8.87 8.87 0 00-3.176 6.8 8.87 8.87 0 003.176 6.8z",
    fill: "#FF5E00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 1h34v-2H6v2zm39 5v20h2V6h-2zm-5 25H6v2h34v-2zM1 26V6h-2v20h2zm5 5a5 5 0 01-5-5h-2a7 7 0 007 7v-2zm39-5a5 5 0 01-5 5v2a7 7 0 007-7h-2zM40 1a5 5 0 015 5h2a7 7 0 00-7-7v2zM6-1a7 7 0 00-7 7h2a5 5 0 015-5v-2z",
    fill: "#F2F4F7"
  })));
}

export default SvgPaymentIconMaster;